import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'
import attachmentHistoryType from '../../shared/attachmentHistoryType'
import {
  requestTokenSourceByLogin,
  requestTokenSourceType,
  requestAccessToken,
} from '../../shared/requestAccessToken'

export class CreativeManagerApproveAttachmentAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, attachmentId, attachmentVersionId, next, complete, error) {
    const token = localStorage.getItem('token')

    const sourceType = requestTokenSourceByLogin(requestTokenSourceType.CARD)
    requestAccessToken(sourceType, (csrfToken) => {
      const httpConfig = {
        url: `/order/${orderId}/${attachmentId}/attachment-timeline`,
        method: 'post',
        data: {
          timelineType: attachmentHistoryType.HISTORY,
          content: 'Approved',
          attachmentVersionId: attachmentVersionId,
        },
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}

export class CreativeManagerReviseAttachmentAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, attachmentId, attachmentVersionId, next, complete, error) {
    const token = localStorage.getItem('token')

    const sourceType = requestTokenSourceByLogin(requestTokenSourceType.CARD)
    requestAccessToken(sourceType, (csrfToken) => {
      const httpConfig = {
        url: `/order/${orderId}/${attachmentId}/attachment-timeline`,
        method: 'post',
        data: {
          timelineType: attachmentHistoryType.HISTORY,
          content: 'Revise',
          attachmentVersionId: attachmentVersionId,
        },
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}

// DEPRECATED
export class GetAttachmentHistoryAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, attachmentId, next, complete, error) {
    const token = localStorage.getItem('token')

    const httpConfig = {
      url: `/order/${orderId}/${attachmentId}/attachment-timeline`,
      method: 'get',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}

// DEPRECATED
export class CommentAttachmentHistoryAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, attachmentId, content, next, complete, error) {
    const token = localStorage.getItem('token')

    const sourceType = requestTokenSourceByLogin(requestTokenSourceType.CARD)
    requestAccessToken(sourceType, (csrfToken) => {
      const httpConfig = {
        url: `/order/${orderId}/${attachmentId}/attachment-timeline`,
        method: 'post',
        data: {
          timelineType: attachmentHistoryType.COMMENT,
          content: content,
        },
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}

// DEPRECATED
export class RequestAttachmentCMReviewAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, attachmentId, requested, next, complete, error) {
    const token = localStorage.getItem('token')

    const sourceType = requestTokenSourceByLogin(requestTokenSourceType.CARD)
    requestAccessToken(sourceType, (csrfToken) => {
      const httpConfig = {
        url: `/order/${orderId}/${attachmentId}/request-cm-review`,
        method: 'post',
        data: {
          requested: requested,
        },
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
